export enum URLLotType {
  lot = 'lot',
  preview = 'preview-lot',
}

export enum LotImageTypes {
  main = 'MAIN',
  carousel = 'CAROUSEL',
  cover = 'COVER',
  catalog = 'CATALOG',
  thumb = 'THUMB',
}
